import React, { useState } from "react";
import { useStructureStore } from "../store/structure-store";
import { useActionsStore } from "../store/actions-store";
import UsersFromGroup from "../picker/UsersFromGroup";
import UsersFromCollection from "../picker/UsersFromCollection";
import UserGroupCollectionPicker from "../picker/UserGroupCollectionPicker";

export const PickerOptionTypes = {
  USER: "user",
  GROUP: "group",
  COLLECTION: "collection",
};

function AddPeopleController({ isRoot = false, setIsAddingToRoot = () => {} }) {
  const [
    choosingUserFromGroupOrCollection,
    setChoosingUserFromGroupOrCollection,
  ] = useState({
    enabled: false,
    data: {},
    type: undefined,
  });

  const { selectedParentUser, checkIsUserInStructure, addUsersToStructure } =
    useStructureStore((state) => ({
      selectedParentUser: state.selectedUser,
      checkIsUserInStructure: state.checkIsUserInStructure,
      addUsersToStructure: state.addUsersToStructure,
    }));

  const setIsAddingPeople = useActionsStore((state) => state.setIsAddingPeople);

  const handleSelect = (selected) => {
    const { type, value, name } = selected;
    if (type === PickerOptionTypes.USER) {
      addUsersToStructure(value, isRoot ? undefined : selectedParentUser?.id);
    }
    if (type === PickerOptionTypes.GROUP) {
      setChoosingUserFromGroupOrCollection({
        enabled: true,
        data: { id: value, name },
        type: PickerOptionTypes.GROUP,
      });
    }
    if (type === PickerOptionTypes.COLLECTION) {
      setChoosingUserFromGroupOrCollection({
        enabled: true,
        data: {
          id: value,
          name,
          filters: selected?.filters || [],
          userGroup: selected?.userGroup || "",
        },
        type: PickerOptionTypes.COLLECTION,
      });
    }
  };

  const cancelSelecting = () => {
    isRoot ? setIsAddingToRoot(false) : setIsAddingPeople(false);
    setChoosingUserFromGroupOrCollection({
      enabled: false,
      data: {},
      type: undefined,
    });
  };

  return (
    <>
      {choosingUserFromGroupOrCollection?.enabled &&
        choosingUserFromGroupOrCollection?.type === PickerOptionTypes.GROUP && (
          <UsersFromGroup
            selectedUser={selectedParentUser}
            groupData={choosingUserFromGroupOrCollection?.data}
            onSelect={(selectedUserAccountIds) => {
              handleSelect({
                type: PickerOptionTypes.USER,
                value: selectedUserAccountIds,
              });
              cancelSelecting();
            }}
            onCancel={() => cancelSelecting()}
          />
        )}

      {choosingUserFromGroupOrCollection?.enabled &&
        choosingUserFromGroupOrCollection?.type ===
          PickerOptionTypes.COLLECTION && (
          <UsersFromCollection
            selectedUser={selectedParentUser}
            collectionData={choosingUserFromGroupOrCollection?.data}
            onSelect={(selectedUserAccountIds) => {
              handleSelect({
                type: PickerOptionTypes.USER,
                value: selectedUserAccountIds,
              });
              cancelSelecting();
            }}
            onCancel={() => cancelSelecting()}
          />
        )}

      {!choosingUserFromGroupOrCollection?.enabled &&
        !choosingUserFromGroupOrCollection?.type && (
          <UserGroupCollectionPicker
            noLabel={isRoot}
            selectedUser={selectedParentUser}
            onSelect={(selected) => {
              const { type } = selected;
              let value = selected.value;
              if (type === PickerOptionTypes.USER) {
                if (checkIsUserInStructure(value)) {
                  return;
                }
                value = [value];
              }
              handleSelect({ ...selected, value });
            }}
            onCancel={() => cancelSelecting()}
            checkIsUserInStructure={checkIsUserInStructure}
          />
        )}
    </>
  );
}

export default AddPeopleController;
